module.exports = { id: "foursquare", url: "/build/app/img/symbols.svg#foursquare", viewBox: "", toString: function() { return this.url; } };